// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-steps__task[data-v-f894aa3a]{font-size:19px;color:#9c9c9c}.task-steps__task__container[data-v-f894aa3a]{border-bottom:1px solid #eaeaea}.task-steps__task.completed .task-steps__task__name[data-v-f894aa3a]{text-decoration:line-through}.task-steps__task.completed.not-achieved .task-steps__task__name[data-v-f894aa3a]{text-decoration:line-through}.task-steps__task__checkbox[data-v-f894aa3a]{font-size:21px}\n", ""]);
// Exports
module.exports = exports;
